import type { SVGProps } from "react";
export const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    className="fill-current"
    {...props}
  >
    <path
      fill="#26B12F"
      fillRule="evenodd"
      d="M17.506 4.41a.833.833 0 0 1 0 1.18l-9.167 9.166a.833.833 0 0 1-1.178 0l-4.167-4.167a.833.833 0 0 1 1.179-1.178l3.577 3.577 8.577-8.577a.833.833 0 0 1 1.179 0"
      clipRule="evenodd"
    />
  </svg>
);
